import React from 'react';

export const DoorLocksCategory = (props) => (
    <svg {...props} viewBox="0 0 25 28" fill="none">
        <path d="M25 7C25 9.2 23.2 11 21 11H9C7.9 11 7 10.1 7 9C7 7.9 7.9 7 9 7H25ZM18 13V19C18 24 14 28 9 28C4 28 0 24 0 19V9C0 4 4 0 9 0C12.5 0 15.6 2 17.1 5H9C6.8 5 5 6.8 5 9C5 11.2 6.8 13 9 13H18ZM9 17C8 17 7.2 17.9 7.3 19L7.8 22C7.9 22.6 8.4 23 9 23C9.6 23 10.1 22.6 10.2 22L10.7 19C10.8 17.9 10 17 9 17Z" />
    </svg>
);
export default DoorLocksCategory;
